import React, { useEffect } from 'react';
import Form from '../forms/Form';
import Input from "../forms/Input";
import Preput from "../forms/Preput";
import Select from "../forms/Select";
import { QuestRoute } from '../api/QuestRoutes';
import ModalFactory from '../Modal';
import HamQuest from '../api/HamQuestGiver';
import { generateId, irregularPluralization } from '../utility/functions';
import Icon from '../forms/Icon';
import styled from 'styled-components';

const Advisory = styled.div`
    font-size: 0.85em;
    font-style: italic;
`;


const AddPlateReadMessageForm = ({platesList, modalId, showPrimaryPlateAdvisory, ...props}) => {
        
    useEffect(() => {
    if (platesList.length <= 0) {
        ModalFactory.update({
        id: modalId,
        title: 'Add Plate Read Message',
        type: 'error',
        body: <>No primary, active plates found for the filtered list.<br />Please modify your filter criteria.</>
        });
    }
    }, [platesList.length]);

    return (
        <Form
            inputs={{
                priority: 1,
                expires: 30,
                message: '',
                plates: platesList
            }}
            onSubmit={e => {
                ModalFactory.close(modalId);

                const id = generateId();
                ModalFactory.promise({
                    id,
                    title: 'Updating',
                    body: 'Adding plate read messages, please wait.',
                });
                return HamQuest.post(QuestRoute.plateReads.messages(''), { ...e })
                    .then(() => {
                        ModalFactory.update({
                            id,
                            type: 'success',
                            title: 'Success',
                            body: <>Plate awards assigned successfully.</>,
                        });

                        if (typeof props.callback === 'function')
                            props.callback();
                    })
                    .catch(ex => {
                        ModalFactory.update({
                            id,
                            type: 'error',
                            title: 'Error!',
                            body: <>{ex.errorMessage || ex.error?.errorMessage}</>
                        });
                    });
            }}
            text='Add Message'
        >
            {({values}) => (
                <>
                    <div>Message will be added for {platesList.length} {irregularPluralization(platesList.length, 'plate', 'plates')}.</div>                   
                    {showPrimaryPlateAdvisory ? <Advisory>(message will be added for primary, active plates only)</Advisory> : <></> }
                    <Preput 
                        label='Message'
                        name='message'
                        required
                    />
                    <Input 
                        label='Priority'
                        name='priority'
                        type='number'
                        step='1'
                        required
                    />
                    <Input 
                        label='Expires (Days)'
                        name='expires'
                        type='number'
                        step='1'
                        min='1'
                        max='365'
                        required
                    />
                </>
            )}
        </Form>
    )
    
}

export default AddPlateReadMessageForm;